// checkboxData.js
const checkboxes = [
    {
      id: "selectTextualReport",
      label: "A PDF of your textual report.",
    },
    {
      id: "selectCSVInputData",
      label: "A CSV of your input data.",
    },
  ];
  
  export default checkboxes;
  